module.exports = __webpack_public_path__ + "img/crop.28b215f7.svg";